export default __webpack_public_path__ + "static/media/tbs-ditolak.5f18ad0f.png";